<template>
  <div class="home">
    <div class="home-header">
      <div class="header-top">
        <div class="location" @click="toPages('/index/chooseAddress')">
          <img src="../assets/images/home/location.png" alt="">
          <span v-if="!roomName && !bedName">请选择地址</span>
          <span v-else>{{ roomName }} {{ bedName }}</span>
        </div>
        <div class="scan" @click="goScanCodePage" v-if="showScan">
          <img src="../assets/images/home/scan.png" alt="">
        </div>
      </div>
      <div class="info clearfix topBg">
        <div class="info-top" v-if="userToken">
          <div class="user">
            <span>{{ userName }}</span>
            <div class="medical-record">
              <span>{{ userType == 0 ? '病历号' : '员工号' }}:</span>
              <span>{{ patientNo }}</span>
            </div>
          </div>
          <div class="toggle" @click="toPages('/my/personal')">
            <img src="../assets/images/home/edit.png" alt="">
            <span>编辑</span>
          </div>
        </div>
        <div v-else class="goLogin">
          <span @click="toPages('/login')">立即登录</span>
        </div>
        <div class="cart" @click="goMenu">
          <div class="tips" v-if="orderNum>0">已订餐</div>
          <div class="cart-title">订&nbsp;&nbsp;&nbsp;&nbsp;餐</div>
          <div class="countBox" v-if="mealStatus!==2">
            <span>{{ mealName }}预定&nbsp;&nbsp;&nbsp;</span>
            <div class="cart-content countDown" v-if="mealStatus===1">
              <van-count-down :time="endDate">
                <template #default="timeData">
                  <span class="time">
                    {{ timeData.hours < 10 ? '0' + timeData.hours : timeData.hours }}:
                    {{ timeData.minutes < 10 ? '0' + timeData.minutes : timeData.minutes }}:
                    {{ timeData.seconds < 10 ? '0' + timeData.seconds : timeData.seconds }}
                  </span>
                </template>
              </van-count-down>
              <span>&nbsp;截止</span>
            </div>
            <span v-if="mealStatus===0">未开始</span>
          </div>
          <div class="cart-content end" v-else>
            <span>{{ mealName }}订餐&nbsp;&nbsp;&nbsp;&nbsp;已截止</span>
          </div>
        </div>
      </div>
    </div>
    <!--余额-->
    <div class="balance">
      <div class="balance-content">
        <div class="amount">
          <span>余额(元)</span>
          <span v-if="userToken" class="money" :class="balance>=0?'':'orangeFont'">{{ balance }}</span>
          <span v-else class="money" style="font-size: 16px" @click="toPages('/login')">立即登录</span>
        </div>
        <button class="depositBtn" :class="balance>=0?'blueBg':'orangeBg'" @click="toPages('/food/deposit')">充值</button>
      </div>
    </div>
    <!--配送管理-->
    <div class="delivery-manage" @click="toPages('/food/deliveryManage')" v-if="userType ==='2'">
      <button>配送管理</button>
    </div>
    <!--当天订单-->
    <div class="order">
      <div class="order-content">
        <div class="days" v-for="(times,index1) in orders" :key="index1">
          <div class="times">
            <div class="title">
              <span>{{ date }}</span>
              <span>{{ times.name }}</span>
            </div>
            <div class="more-order" @click="toPages('/my/orderRecord?orderId=0')">更多订单</div>
          </div>
          <div class="tips" v-if="orderNum>1">当前时段你预订了多份餐品</div>
          <div>
            <div class="food-list" v-if="times.mealOrders.length !== 0">
              <div class="food-item" v-for="(item,index2) in times.mealOrders" :key="index1+index2"
                   @click="goodsDetails(item.payStatus)">
                <div class="food">
                  <div class="food-info">
                    <div class="food-img">
                      <img :src="item.goodsImage" alt="">
                    </div>
                    <div class="food-detail">
                      <span class="food-name oneClampEllipsisType1">{{ item.goodsName }}</span>
                      <span class="food-describe oneClampEllipsisType2">{{ item.goodsRemark }}</span>
                      <span class="food-num">x {{ item.num }}</span>
                    </div>
                  </div>
                  <div class="state blueFont" v-if="item.payStatus===2">配餐中</div>
                  <div class="state blueFont" v-else-if="item.payStatus===3">送餐中</div>
                  <div class="state" v-else-if="item.payStatus===4">已完成</div>
                  <div class="state orangeFont" v-else>待支付</div>
                </div>
                <div class="balance-low" v-if="item.tips === 1">您的余额不足，请立即充值，否则将影响餐品配送</div>
              </div>
            </div>
            <div class="empty-order" v-else>
              <img src="../assets/images/home/empty_bg.png" alt="">
              <div class="empty-tips">您还未订餐</div>
              <button @click="goMenu">去订餐</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部导航 -->
    <bottom-nav></bottom-nav>
  </div>
</template>

<script>
import bottomNav from "../components/bottomNav.vue";

export default {
  name: "Home",
  data() {
    return {
      showScan: false, //是否显示扫一扫
      userName: "你好",
      balance: '0.00',
      patientNo: "",
      orders: [],
      mealStatus: 0, //点餐状态
      mealName: "", //早中晚餐
      endDate: 0,
      date: "",
      orderNum: 0, //当前时段订单数
      roomName: "", //护理站
      bedName: "", //床号
      userToken: "",
      userType: 0
    };
  },
  components: {
    bottomNav,
  },
  computed: {},
  created() {
    this.isWechat();
    this.userToken = window.localStorage.getItem("user_token");
    this.userType = localStorage.getItem('user_type');
  },
  mounted() {
    // 页面加载完毕加载
    window.addEventListener("scroll", this.handleScroll);
    if (this.userToken) {
      this.getHomeDate();
    }
  },
  methods: {
    goodsDetails(status) {
      if (status < 2) {
        this.$router.push('/my/orderRecord?orderId=1');
      } else if (status == 2 || status == 3) {
        this.$router.push(`/my/orderRecord?orderId=2`);
      } else {
        this.$router.push(`/my/orderRecord?orderId=0`);
      }
    },
    //前往配送管理
    toPages(url) {
      window.sessionStorage.setItem("skipAddress", encodeURIComponent(window.location.href));
      this.$router.push(url);
    },
    getHomeDate() {
      this.$post("index/index").then((res) => {
        if (res) {
          this.userName = res.data.userName;
          this.balance = res.data.balance ? res.data.balance : '0.00';
          this.date = res.data.date;
          this.patientNo = res.data.patientNo;
          this.mealStatus = res.data.mealStatus;
          this.mealName = res.data.mealName;
          this.orders = res.data.orders;
          this.endDate = res.data.endDate - (+new Date());
          this.orderNum = res.data.orderNum;
          this.roomName = res.data.roomName;
          this.bedName = res.data.bedName;
          if (!res.data.openId && this.showScan) {//判断是否已授权、是否在微信浏览器
            const local = this.BASE.BASE_URL + "/loading";
            window.location.replace(`${this.BASE.WECHAT_AUTHORIZE_URL}?returnUrl=${local}`);
          }
        }
      });
    },
    //判断是否微信浏览器
    isWechat() {
      let ua = navigator.userAgent.toLowerCase();
      if (/micromessenger/.test(ua)) {
        this.showScan = true;
      } else {
        this.showScan = false;
      }
    },
    //跳转扫一扫
    goScanCodePage() {
      this.$router.push({path: "/index/scan",});
    },
    goMenu() {
      this.$router.push({name: "menu"});
    },
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less" scoped>
.blueFont {
  color: #126afc;
}

.orangeFont {
  color: #fc3912;
}

.box {
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 1);
}

.home {
  padding-bottom: 60px;
  font-family: PingFangSC-regular;

  .home-header {
    font-family: SourceHanSansSC-Bold;
    color: #ffffff;
    font-size: 16px;
    font-weight: bold;

    .header-top {
      height: 44px;
      background: #126afc;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;

      .location {
        display: flex;
        align-items: center;

        img {
          height: 18px;
          margin-right: 5px;
        }
      }

      .scan {
        img {
          width: 35px;
        }
      }
    }

    .info {
      padding: 20px 15px;

      .info-top {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .user {
          display: flex;
          flex-direction: column;
          font-size: 18px;

          .medical-record {
            display: flex;
            align-items: center;
            margin-top: 15px;

            span:nth-child(1) {
              font-size: 15px;
            }

            span:nth-child(2) {
              font-size: 17px;
              margin-left: 6px;
            }
          }
        }

        .toggle {
          width: 64px;
          height: 30px;
          background: rgba(250, 250, 250, 0.2);
          border-radius: 15px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          font-weight: normal;

          img {
            width: 12px;
          }

          span {
            margin-left: 4px;
          }
        }
      }

      .goLogin {
      }

      .cart {
        width: 100%;
        height: 90px;
        background: url("../assets/images/home/book_bg.png") no-repeat;
        background-size: cover;
        border-radius: 8px;
        margin-top: 25px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;

        .tips {
          width: 77px;
          height: 20px;
          background: #fc3912;
          border-radius: 0 0 8px 8px;
          font-size: 12px;
          text-align: center;
          line-height: 20px;
          position: absolute;
          top: 0;
          left: 10px;
        }

        .cart-title {
          color: #042151;
          font-size: 20px;
        }

        .cart-content {
          font-size: 14px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          font-weight: normal;
        }

        .countBox {
          display: flex;
          align-items: center;
          color: #9eb5fe;
          font-size: 14px;
          font-weight: normal;
          margin-top: 12px;

          .countDown {
            .time {
              color: #9eb5fe;
              font-size: 14px;
            }
          }
        }

        .end {
          color: #fc3912;
          margin-top: 12px;
        }
      }
    }
  }

  .balance {
    width: 100%;

    .balance-content {
      height: 90px;
      margin: 0 15px;
      border-radius: 8px;
      background: #ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .amount {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 30px;
        color: #042151;

        span:first-child {
          font-size: 15px;
        }

        .money {
          font-size: 23px;
          font-weight: 800;
          margin-top: 8px;
        }
      }

      .depositBtn {
        width: 80px;
        height: 35px;
        border: none;
        margin-right: 25px;
        font-size: 15px;
        color: #ffffff;
        border-radius: 17.5px;
      }

      .blueBg {
        background: #126afc;
      }

      .orangeBg {
        background: #fc3912;
      }
    }
  }

  .delivery-manage {
    padding: 0 15px;
    margin-top: 15px;

    button {
      width: 100%;
      height: 60px;
      background: #126afc;
      border-radius: 8px;
      border: none;
      font-size: 20px;
      font-weight: bold;
      color: #ffffff;
    }
  }

  .order {
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;

    .order-content {
      margin: 0 15px;

      .days {
        .times {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .title {
            font-size: 18px;
            color: #042151;
            font-weight: bold;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            span:nth-child(2) {
              margin-left: 15px;
            }
          }

          .title::before {
            content: "";
            display: block;
            width: 3px;
            height: 20px;
            background: #126afc;
            border-radius: 3px;
            margin-right: 10px;
          }

          .more-order {
            font-size: 12px;
            color: #999999;
          }
        }

        .tips {
          margin-top: 10px;
          font-size: 12px;
          color: #fc3912;
          margin-left: 13px;
        }
      }

      .food-list {
        padding-top: 5px;
        padding-bottom: 50px;

        .food-item {
          position: relative;

          .food {
            height: 90px;
            border-radius: 8px;
            background: #ffffff;
            position: relative;
            margin-top: 10px;

            .food-info {
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;

              .food-img {
                width: 60px;
                height: 60px;
                margin-left: 18px;

                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 8px;
                }
              }

              .food-detail {
                height: 100%;
                margin-left: 16px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                font-size: 12px;
                color: #999999;

                .food-name {
                  font-size: 15px;
                  color: #042151;
                  margin-top: 15px;
                  font-weight: bold;
                }

                .food-describe {
                  width: 245px;
                  margin-top: 13px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }

                .food-num {
                  margin-top: 10px;
                }
              }
            }

            .state {
              position: absolute;
              right: 16px;
              bottom: 15px;
              font-size: 14px;
            }
          }

          .balance-low {
            width: 100%;
            height: 30px;
            background: #fff5e3;
            font-size: 12px;
            color: #fc3912;
            text-align: center;
            line-height: 30px;
            position: absolute;
            bottom: -28px;
            left: 0;
          }
        }
      }

      .empty-order {
        margin-top: 45px;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          height: 108px;
        }

        .empty-tips {
          font-size: 12px;
          color: #cccccc;
          margin-top: 17px;
        }

        button {
          width: 100px;
          height: 35px;
          background: #126afc;
          border-radius: 18px;
          border: none;
          font-size: 15px;
          color: #ffffff;
          margin-top: 22px;
        }
      }
    }
  }
}
</style>